import {
  SHOW_FOODPROFILE_POPUP,
  HIDE_FOODPROFILE_POPUP,
  TOGGLE_FOODPROFILE_POPUP,
  SET_FOODPROFILE_POPUP_STEP,
} from '../actions/foodProfilePopup';

export const initialState = {
  isPopupOpened: false,
  currentStep: 0,
};

export default function foodProfilePopup(state = initialState, action) {
  switch (action.type) {
    case SHOW_FOODPROFILE_POPUP: {
      return {
        ...state,
        isPopupOpened: true,
        currentStep: action.data,
      };
    }
    case HIDE_FOODPROFILE_POPUP: {
      return {
        ...state,
        isPopupOpened: false,
        currentStep: 0,
      };
    }
    case TOGGLE_FOODPROFILE_POPUP: {
      return {
        ...state,
        isPopupOpened: !state.isPopupOpened,
        currentStep: 0,
      };
    }
    case SET_FOODPROFILE_POPUP_STEP: {
      return {
        ...state,
        currentStep: action.data,
      };
    }
    default: {
      return state;
    }
  }
}
